import { DNATypeEnum } from '@shared/enums';
import { TextValue } from '@shared/interfaces';

export const dnaTypesTextValue: TextValue[] = [
    { text: 'order.reactionDetails.dnaType.PCR', value: DNATypeEnum.PCR },
    { text: 'order.reactionDetails.dnaType.plasmid', value: DNATypeEnum.PLASMID },
];
